import {NgModule} from '@angular/core';
import {TopNavComponent} from './top-nav.component';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {AuthModule} from '../../components/security/authorization/auth.module';

@NgModule({
    imports: [CommonModule, RouterModule, AuthModule],
    declarations: [TopNavComponent],
    exports: [TopNavComponent]
})
export class TopNavModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/navigation/top/top-nav.module.ts